import { createFileRoute } from '@tanstack/react-router'
import EditionPriceAndCost from 'Edition/components/sections/General/EditionPriceAndCost/EditionPriceAndCost'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-price-and-cost')({
    component: EditionPriceAndCost,
})
